import ProductHelper from "@js/helpers/ProductHelper";
import { BridgingPersonalGuaranteeLevelEnum } from "@js/models/enum/BridgingPersonalGuaranteeLevelEnum";
import { MaxFlatUnitPriceEnum } from "@js/models/enum/MaxFlatUnitPriceEnum";
import { MaxHouseSalePriceEnum } from "@js/models/enum/MaxHouseSalePriceEnum";
import { MaxIndividualUnitPriceEnum } from "@js/models/enum/MaxIndividualUnitPriceEnum";
import { MaxSqFtSalePriceEnum } from "@js/models/enum/MaxSqFtSalePriceEnum";
import { PersonalGuaranteeLevelEnum } from "@js/models/enum/PersonalGuaranteeLevelEnum";
import { ShareholderDepositRequiredEnum } from "@js/models/enum/ShareholderDepositRequiredEnum";
import { SiteTypeEnum } from "@js/models/enum/SiteTypeEnum";

import {
  BillingFrequencyEnum,
  BorrowingEntityTypeEnum,
  BrokerNetworkEnum,
  BrokerSubscriptionTypeEnum,
  BuildProcurementTypeEnum,
  BuildStageEnum,
  CRMEnum,
  CaseLenderStateEnum,
  CaseStatusEnum,
  ChargeTypeEnum,
  ConditionEnum,
  EPCRatingTypeEnum,
  EWS1GradeTypeEnum,
  ExistingPlanningChangeTypeEnum,
  ExitStrategyEnum,
  FixedRateTermEnum,
  InterestRateBasis,
  InterestRateTypeEnum,
  InterestServicedorRolledEnum,
  LandOrPropertyEnum,
  LenderSubscriptionTypeEnum,
  LinkTypeEnum,
  LoanCompletionTypeEnum,
  LoanPurposeEnum,
  LoanRepaymentTypeEnum,
  LocationEnum,
  MaritalStatusEnum,
  MaxCommercialFloorspaceEnum,
  NonPhysicalValuationEnum,
  OwnNewDevelopmentEnum,
  OwnOrPurchaseEnum,
  OwnershipRoleEnum,
  PlanningPermissionTypeEnum,
  PlanningResponsibilityEnum,
  PreAgreementEnum,
  PreviousDevelopmentsEnum,
  ProductFamilyEnum,
  ProductTypeEnum,
  PropertyTypeEnum,
  ReferrerEnum,
  RefurbishmentLevelEnum,
  ScheduleDescriptionTypeEnum,
  SourceOfIncomeEnum,
  TeamSizeEnum,
  TenureEnum,
  TimeLeftOnLeaseEnum,
  TitleEnum,
  TradingPeriodEnum,
  ValuationMethodEnum,
  YesNoMaybe,
} from "@src/apis/ModularClient";

export interface ListItem {
  key: number;
  displayName: string;
  order?: number;
  isDivider?: boolean;
  isGroupLabel?: boolean;
}

export class SelectListService {
  SelectLists: { [key: string]: ListItem[] } = {};
  lastOwnOrPurchase: any;
  lastLandOrProperty: any;

  static $inject = [];

  constructor() {}

  GetMaritalStatusOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaritalStatusEnum"] == null) {
      this.SelectLists["MaritalStatusEnum"] = [
        { key: MaritalStatusEnum.Single, displayName: "Single", order: 1 },
        { key: MaritalStatusEnum.Married, displayName: "Married", order: 2 },
        {
          key: MaritalStatusEnum.LivingWithPartner,
          displayName: "Living With Partner",
          order: 3,
        },
        { key: MaritalStatusEnum.Widowed, displayName: "Widowed", order: 4 },
        {
          key: MaritalStatusEnum.CivilPartnership,
          displayName: "Civil Partnership",
          order: 5,
        },
        { key: MaritalStatusEnum.Divorced, displayName: "Divorced", order: 6 },
        {
          key: MaritalStatusEnum.Separated,
          displayName: "Separated",
          order: 7,
        },
      ];
    }

    return this.SelectLists["MaritalStatusEnum"].sort((a, b) => a.order - b.order);
  }

  GetTenureTypes(productType: ProductTypeEnum): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["TenureEnum"] == null) {
      if (productType != ProductTypeEnum.BridgingPreconstruction) {
        this.SelectLists["TenureEnum"] = [
          { key: TenureEnum.Freehold, displayName: "Freehold", order: 1 },
          { key: TenureEnum.Leasehold, displayName: "Leasehold", order: 3 },
        ];
      } else {
        this.SelectLists["TenureEnum"] = [
          { key: TenureEnum.Freehold, displayName: "Freehold", order: 1 },
          {
            key: TenureEnum.ShareOfFreehold,
            displayName: "Share Of Freehold",
            order: 2,
          },
          { key: TenureEnum.Leasehold, displayName: "Leasehold", order: 3 },
          {
            key: TenureEnum.CommonholdOwnership,
            displayName: "Commonhold Ownership",
            order: 4,
          },
          //{ key: TenureEnum.JointOwnershipTenantsInCommon, displayName: 'Joint Ownership - Tenants In Common', order: 5 },
          //{ key: TenureEnum.JointOwnershipJointTenants, displayName: 'Joint Ownership - Joint Tenants', order: 6 }
        ];
      }
    }

    return this.SelectLists["TenureEnum"].sort((a, b) => a.order - b.order);
  }

  GetNumberOfPreviousDevelopments(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PreviousDevelopmentsEnum"] == null) {
      this.SelectLists["PreviousDevelopmentsEnum"] = [
        { key: PreviousDevelopmentsEnum.One, displayName: "1", order: 1 },
        { key: PreviousDevelopmentsEnum.Two, displayName: "2", order: 2 },
        { key: PreviousDevelopmentsEnum.Three, displayName: "3", order: 3 },
        {
          key: PreviousDevelopmentsEnum.FourOrMore,
          displayName: "4 +",
          order: 4,
        },
      ];
    }
    return this.SelectLists["PreviousDevelopmentsEnum"].sort((a, b) => a.order - b.order);
  }

  GetNumberOfPreviousDevelopmentsForBridging(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PreviousDevelopmentsEnumBridging"] == null) {
      this.SelectLists["PreviousDevelopmentsEnumBridging"] = [
        {
          key: PreviousDevelopmentsEnum.OneOrTwo,
          displayName: "1 - 2",
          order: 1,
        },
        {
          key: PreviousDevelopmentsEnum.ThreeOrMore,
          displayName: "3 +",
          order: 2,
        },
      ];
    }
    return this.SelectLists["PreviousDevelopmentsEnumBridging"].sort((a, b) => a.order - b.order);
  }

  GetShareholderDepositRequired(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ShareholderDepositRequiredEnum"] == null) {
      this.SelectLists["ShareholderDepositRequiredEnum"] = [
        {
          key: ShareholderDepositRequiredEnum.None,
          displayName: "0%",
          order: 1,
        },
        {
          key: ShareholderDepositRequiredEnum.UpTo25Percent,
          displayName: "Up to 25%",
          order: 2,
        },
        {
          key: ShareholderDepositRequiredEnum.TwentyFiveTo50Percent,
          displayName: "25% - 50%",
          order: 3,
        },
        {
          key: ShareholderDepositRequiredEnum.FiftyPercentPlus,
          displayName: "51%+",
          order: 4,
        },
      ];
    }
    return this.SelectLists["ShareholderDepositRequiredEnum"].sort((a, b) => a.order - b.order);
  }

  GetPersonalGuaranteeLevels(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PersonalGuaranteeLevelEnum"] == null) {
      this.SelectLists["PersonalGuaranteeLevelEnum"] = [
        {
          key: PersonalGuaranteeLevelEnum.UpTo20Percent,
          displayName: "Up to 20%",
          order: 1,
        },
        {
          key: PersonalGuaranteeLevelEnum.TwentyOneTo35Percent,
          displayName: "21-35%",
          order: 2,
        },
        {
          key: PersonalGuaranteeLevelEnum.ThirtySixTo50Percent,
          displayName: "36-50%",
          order: 3,
        },
        {
          key: PersonalGuaranteeLevelEnum.OneHundredPercent,
          displayName: "51-100%",
          order: 4,
        },
      ];
    }
    return this.SelectLists["PersonalGuaranteeLevelEnum"].sort((a, b) => a.order - b.order);
  }

  GetBridgingPersonalGuaranteeLevels(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BridgingPersonalGuaranteeLevelEnum"] == null) {
      this.SelectLists["BridgingPersonalGuaranteeLevelEnum"] = [
        {
          key: BridgingPersonalGuaranteeLevelEnum.None,
          displayName: "0%",
          order: 1,
        },
        {
          key: BridgingPersonalGuaranteeLevelEnum.OneToTwentyFivePercent,
          displayName: "1-25%",
          order: 2,
        },
        {
          key: BridgingPersonalGuaranteeLevelEnum.TwentySixToFiftyPercent,
          displayName: "26-50%",
          order: 3,
        },
        {
          key: BridgingPersonalGuaranteeLevelEnum.FiftyOneToOneHundredPercent,
          displayName: "51-100%",
          order: 4,
        },
      ];
    }
    return this.SelectLists["BridgingPersonalGuaranteeLevelEnum"].sort((a, b) => a.order - b.order);
  }

  GetMaxHouseSalePrices(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaxHouseSalePriceEnum"] == null) {
      this.SelectLists["MaxHouseSalePriceEnum"] = [
        {
          key: MaxHouseSalePriceEnum.NoMax,
          displayName: "Above £5m",
          order: 5,
        },
        {
          key: MaxHouseSalePriceEnum.UpTo1Million,
          displayName: "Up to £1m",
          order: 2,
        },
        {
          key: MaxHouseSalePriceEnum.UpTo2Million,
          displayName: "Up to £2m",
          order: 3,
        },
        {
          key: MaxHouseSalePriceEnum.UpTo5Million,
          displayName: "Up to £5m",
          order: 4,
        },
      ];
    }

    return this.SelectLists["MaxHouseSalePriceEnum"].sort((a, b) => a.order - b.order);
  }

  GetMaxFlatUnitPrices(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaxFlatUnitPriceEnum"] == null) {
      this.SelectLists["MaxFlatUnitPriceEnum"] = [
        { key: MaxFlatUnitPriceEnum.None, displayName: "Above £3m", order: 5 },
        {
          key: MaxFlatUnitPriceEnum.UpTo1Million,
          displayName: "Up to £1m",
          order: 2,
        },
        {
          key: MaxFlatUnitPriceEnum.UpTo2Million,
          displayName: "Up to £2m",
          order: 3,
        },
        {
          key: MaxFlatUnitPriceEnum.UpTo3Million,
          displayName: "Up to £3m",
          order: 4,
        },
      ];
    }
    return this.SelectLists["MaxFlatUnitPriceEnum"].sort((a, b) => a.order - b.order);
  }

  GetMaxSqFtSalePrices(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaxSqFtSalePriceEnum"] == null) {
      this.SelectLists["MaxSqFtSalePriceEnum"] = [
        {
          key: MaxSqFtSalePriceEnum.NoMax,
          displayName: "Above £1500",
          order: 5,
        },
        {
          key: MaxSqFtSalePriceEnum.UpTo850,
          displayName: "Up to £850",
          order: 2,
        },
        {
          key: MaxSqFtSalePriceEnum.UpTo1000,
          displayName: "Up to £1000",
          order: 3,
        },
        {
          key: MaxSqFtSalePriceEnum.UpTo1500,
          displayName: "Up to £1500",
          order: 4,
        },
      ];
    }
    return this.SelectLists["MaxSqFtSalePriceEnum"].sort((a, b) => a.order - b.order);
  }

  GetInterestRateBasis(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["InterestRateBasis"] == null) {
      this.SelectLists["InterestRateBasis"] = [
        { key: InterestRateBasis.BaseRate, displayName: "Base Rate", order: 1 },
        { key: InterestRateBasis.Sonia, displayName: "Sonia", order: 3 },
        {
          key: InterestRateBasis.LendersOwnSVR,
          displayName: "Lenders Own SVR",
          order: 2,
        },
      ];
    }
    return this.SelectLists["InterestRateBasis"].sort((a, b) => a.order - b.order);
  }

  GetReferrerOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ReferrerOptions"] == null) {
      this.SelectLists["ReferrerOptions"] = [
        {
          key: ReferrerEnum.OtherSearch,
          displayName: "Please Select",
          order: 1,
        },
        {
          key: ReferrerEnum.GoogleSearch,
          displayName: "Google Search",
          order: 9,
        },
        {
          key: ReferrerEnum.OtherSearch,
          displayName: "Other Search",
          order: 14,
        },
        { key: ReferrerEnum.LinkedIn, displayName: "LinkedIn", order: 10 },
        { key: ReferrerEnum.Facebook, displayName: "Facebook", order: 7 },
        { key: ReferrerEnum.Agent, displayName: "Estate Agent", order: 5 },
        {
          key: ReferrerEnum.ExistingUser,
          displayName: "Existing User",
          order: 6,
        },
        {
          key: ReferrerEnum.BrickflowConsultant,
          displayName: this.getAppName() + " Consultant",
          order: 20,
        },
        { key: ReferrerEnum.Broker, displayName: "Broker", order: 3 },
        { key: ReferrerEnum.Developer, displayName: "Developer", order: 4 },
        {
          key: ReferrerEnum.MassReports,
          displayName: "Mass Reports",
          order: 11,
        },
        { key: ReferrerEnum.NimbusMaps, displayName: "Nimbus Maps", order: 12 },
        {
          key: ReferrerEnum.PressRelease,
          displayName: "Press Release",
          order: 17,
        },
        { key: ReferrerEnum.TheRodcast, displayName: "The Rodcast", order: 16 },
        { key: ReferrerEnum.OTM, displayName: "OnTheMarket", order: 13 },
        {
          key: ReferrerEnum.WordOfMouth,
          displayName: "Word of Mouth",
          order: 19,
        },
        {
          key: ReferrerEnum.PersonalRecommendation,
          displayName: "Personal Recommendation",
          order: 15,
        },
        { key: ReferrerEnum.Ad, displayName: "Ad", order: 2 },
        {
          key: ReferrerEnum.SocialMedia,
          displayName: "Social Media",
          order: 18,
        },
        { key: ReferrerEnum.FIBA, displayName: "FIBA", order: 8 },
        { key: ReferrerEnum.Other, displayName: "Other", order: 21 },
      ];
    }
    return this.SelectLists["ReferrerOptions"].sort((a, b) => a.order - b.order);
  }

  GetBillingFrequencyOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BillingFrequencyOptions"] == null) {
      this.SelectLists["BillingFrequencyOptions"] = [
        { key: BillingFrequencyEnum.Monthly, displayName: "Monthly", order: 1 },
        { key: BillingFrequencyEnum.Yearly, displayName: "Annually", order: 2 },
      ];
    }
    return this.SelectLists["BillingFrequencyOptions"];
  }

  GetTeamSizeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["TeamSizeOptions"] == null) {
      this.SelectLists["TeamSizeOptions"] = [
        { key: TeamSizeEnum.One, displayName: "1", order: 1 },
        { key: TeamSizeEnum.TwoToFive, displayName: "2 - 5", order: 2 },
        { key: TeamSizeEnum.SixToTen, displayName: "6 - 10", order: 3 },
        { key: TeamSizeEnum.ElevenToTwenty, displayName: "11 - 20", order: 4 },
        { key: TeamSizeEnum.TwentyOnePlus, displayName: "21+", order: 5 },
      ];
    }

    return this.SelectLists["TeamSizeOptions"];
  }

  getAppName(): string {
    const lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      return lsd;
    } else {
      return "Brickflow";
    }
  }

  GetYesNo(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["YesNoEnum"] == null) {
      this.SelectLists["YesNoEnum"] = [
        { key: YesNoMaybe.No, displayName: "No", order: 1 },
        { key: YesNoMaybe.Yes, displayName: "Yes", order: 2 },
      ];
    }
    return this.SelectLists["YesNoEnum"].sort((a, b) => a.order - b.order);
  }

  GetOwnOrPurchase(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["OwnOrPurchaseEnum"] == null) {
      this.SelectLists["OwnOrPurchaseEnum"] = [
        { key: OwnOrPurchaseEnum.Own, displayName: "Own", order: 1 },
        {
          key: OwnOrPurchaseEnum.Purchasing,
          displayName: "Purchasing",
          order: 2,
        },
      ];
    }
    return this.SelectLists["OwnOrPurchaseEnum"].sort((a, b) => a.order - b.order);
  }

  GetChargeType(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ChargeTypeEnum"] == null) {
      this.SelectLists["ChargeTypeEnum"] = [
        {
          key: ChargeTypeEnum.FirstCharge,
          displayName: "First Charge",
          order: 1,
        },
        {
          key: ChargeTypeEnum.SecondCharge,
          displayName: "Second Charge",
          order: 2,
        },
      ];
    }
    return this.SelectLists["ChargeTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetYesNoForBridging(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["YesNoEnumBridging"] == null) {
      this.SelectLists["YesNoEnumBridging"] = [
        { key: YesNoMaybe.No, displayName: "No", order: 1 },
        { key: YesNoMaybe.Yes, displayName: "Yes", order: 2 },
      ];
    }
    return this.SelectLists["YesNoEnumBridging"].sort((a, b) => a.order - b.order);
  }

  GetBuildingConditionType(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["conditionEnum"] == null) {
      this.SelectLists["conditionEnum"] = [
        { key: ConditionEnum.Good, displayName: "Good", order: 1 },
        { key: ConditionEnum.Fair, displayName: "Fair", order: 2 },
        { key: ConditionEnum.Poor, displayName: "Poor", order: 2 },
      ];
    }
    return this.SelectLists["conditionEnum"].sort((a, b) => a.order - b.order);
  }

  GetSiteType(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["SiteTypeEnum"] == null) {
      this.SelectLists["SiteTypeEnum"] = [
        {
          key: SiteTypeEnum.ExistingBuilding,
          displayName: "Existing Building",
          order: 1,
        },
        { key: SiteTypeEnum.Land, displayName: "Land", order: 2 },
      ];
    }
    return this.SelectLists["SiteTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetProductTypeOptions(isUserDashboard: boolean = false): ListItem[] {
    const selectListName: string = isUserDashboard ? "UserDashboardProductType" : "ProductTypeEnum";

    if (this.SelectLists == null || this.SelectLists[selectListName] == null) {
      this.SelectLists[selectListName] = [
        { key: ProductTypeEnum.None, displayName: "None", order: 1 },
        {
          key: ProductTypeEnum.Development,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.Development),
          order: 2,
        },
        {
          key: ProductTypeEnum.BridgingPreconstruction,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.BridgingPreconstruction),
          order: 3,
        },
        {
          key: ProductTypeEnum.BridgingDeveloperExit,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.BridgingDeveloperExit) + " Bridge",
          order: 4,
        },
        {
          key: ProductTypeEnum.BridgingRefurb,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.BridgingRefurb) + " Bridge",
          order: 5,
        },
        {
          key: ProductTypeEnum.CommercialInvestment,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.CommercialInvestment),
          order: 6,
        },
        {
          key: ProductTypeEnum.BridgingPurchaseOrRefinance,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.BridgingPurchaseOrRefinance) + " Bridge",
          order: 7,
        },
      ];

      if (isUserDashboard) {
        this.SelectLists[selectListName].push({
          key: ProductTypeEnum.CommercialOwnerOccupied,
          displayName: "Commercial Owner Occupied",
          order: 8,
        });
      } else {
        this.SelectLists[selectListName].push({
          key: ProductTypeEnum.CommercialOwnerOccupied,
          displayName: ProductHelper.getProductTypeDisplayText(ProductTypeEnum.CommercialOwnerOccupied),
          order: 8,
        });
      }
    }

    return this.SelectLists[selectListName].sort((a, b) => a.order - b.order);
  }

  GetProductFamilyOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ProductFamilyEnum"] == null) {
      this.SelectLists["ProductFamilyEnum"] = [
        {
          key: ProductFamilyEnum.Development,
          displayName: "Development Finance",
          order: 1,
        },
        { key: ProductFamilyEnum.Bridging, displayName: "Bridging", order: 2 },
        {
          key: ProductFamilyEnum.Commercial,
          displayName: "Commercial",
          order: 3,
        },
      ];
    }
    return this.SelectLists["ProductFamilyEnum"].sort((a, b) => a.order - b.order);
  }

  GetInterestServiceOrRoll(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["interestServicedOrRolledEnum"] == null) {
      this.SelectLists["interestServicedOrRolledEnum"] = [
        {
          key: InterestServicedorRolledEnum.Serviced,
          displayName: "Serviced",
          order: 2,
        },
        {
          key: InterestServicedorRolledEnum.Rolled,
          displayName: "Rolled up",
          order: 1,
        },
      ];
    }
    return this.SelectLists["interestServicedOrRolledEnum"].sort((a, b) => a.order - b.order);
  }
  GetSourceOfIncomeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["sourceOfIncomeEnum"] == null) {
      this.SelectLists["sourceOfIncomeEnum"] = [
        {
          key: SourceOfIncomeEnum.CurrentRentalFromThisProperty,
          displayName: "Current rental from this property",
          order: 1,
        },
        {
          key: SourceOfIncomeEnum.FutureRentalFromThisProperty,
          displayName: "Future rental from this property",
          order: 4,
        },
        {
          key: SourceOfIncomeEnum.FundsFromYourSavings,
          displayName: "Funds from your savings",
          order: 3,
        },
        {
          key: SourceOfIncomeEnum.FundsFromYourIncome,
          displayName: "Funds from your income",
          order: 2,
        },
      ];
    }
    return this.SelectLists["sourceOfIncomeEnum"].sort((a, b) => a.order - b.order);
  }

  GetLoanPurposeOptions(isRegulatedBridging: boolean = false): ListItem[] {
    if (isRegulatedBridging) {
      this.SelectLists["loanPurposeEnum"] = [
        {
          key: LoanPurposeEnum.AuctionPurchase,
          displayName: "Auction purchase ",
          order: 1,
        },
        {
          key: LoanPurposeEnum.ChainBreak,
          displayName: "Chain break ",
          order: 2,
        },
        {
          key: LoanPurposeEnum.Refurbishment,
          displayName: "Refurbishment",
          order: 3,
        },
        {
          key: LoanPurposeEnum.AnyOtherLegalPurpose,
          displayName: "Any other legal purpose (e.g. probate, tax bill etc.)",
          order: 4,
        },
      ];
    } else {
      this.SelectLists["loanPurposeEnum"] = [
        {
          key: LoanPurposeEnum.Speed,
          displayName: "Speed i.e. auction purpose",
          order: 1,
        },
        {
          key: LoanPurposeEnum.DepositForAnotherPurchase,
          displayName: "Deposit for another purchase",
          order: 2,
        },
        { key: LoanPurposeEnum.Rebridge, displayName: "Rebridge", order: 3 },
        {
          key: LoanPurposeEnum.Other,
          displayName: "Other, please state",
          order: 4,
        },
      ];
    }
    return this.SelectLists["loanPurposeEnum"].sort((a, b) => a.order - b.order);
  }

  GetPlanningOptions(
    OwnOrPurchase: OwnOrPurchaseEnum,
    LandOrProperty: LandOrPropertyEnum,
    showPermittedDevelopment: boolean = true,
  ): ListItem[] {
    if (this.SelectLists == null) {
      this.SelectLists = {};
    }

    if (
      !this.SelectLists["planningEnum"] ||
      this.lastOwnOrPurchase !== OwnOrPurchase ||
      this.lastLandOrProperty !== LandOrProperty
    ) {
      this.lastOwnOrPurchase = OwnOrPurchase;
      this.lastLandOrProperty = LandOrProperty;

      const ownOrPurchase = OwnOrPurchase == OwnOrPurchaseEnum.Own ? "Own" : "Buying";
      const landOrProperty = LandOrProperty == LandOrPropertyEnum.Land ? "land" : "property";
      this.SelectLists["planningEnum"] = [
        {
          key: PlanningPermissionTypeEnum.NoPlanning,
          displayName: `${ownOrPurchase} ${landOrProperty} with no planning`,
          order: 2,
        },
        {
          key: PlanningPermissionTypeEnum.OutlinePlanning,
          displayName: `${ownOrPurchase} ${landOrProperty} with outline planning`,
          order: 3,
        },
        {
          key: PlanningPermissionTypeEnum.DetailedPlanning,
          displayName: `${ownOrPurchase} ${landOrProperty} with detailed planning that you wish to vary`,
          order: 1,
        },
      ];
    }

    const permittedDevelopmentIndex = this.SelectLists["planningEnum"]
      .map((e) => e.key)
      .indexOf(PlanningPermissionTypeEnum.PermittedDevelopment);

    if (showPermittedDevelopment && permittedDevelopmentIndex == -1) {
      this.SelectLists["planningEnum"].push({
        key: PlanningPermissionTypeEnum.PermittedDevelopment,
        displayName: "Permitted development",
        order: 4,
      });
    } else if (!showPermittedDevelopment && permittedDevelopmentIndex > -1) {
      this.SelectLists["planningEnum"].splice(permittedDevelopmentIndex);
    }

    return this.SelectLists["planningEnum"].sort((a, b) => a.order - b.order);
  }

  GetPlanningStatusAtStartOfDevelopmentOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PlanningStatusAtStartOfDevelopment"] == null) {
      this.SelectLists["PlanningStatusAtStartOfDevelopment"] = [
        {
          key: PlanningPermissionTypeEnum.NoPlanning,
          displayName: "No planning",
          order: 2,
        },
        {
          key: PlanningPermissionTypeEnum.OutlinePlanning,
          displayName: "Outline planning",
          order: 3,
        },
        {
          key: PlanningPermissionTypeEnum.DetailedPlanning,
          displayName: "Detailed planning that you wish to vary",
          order: 1,
        },
        {
          key: PlanningPermissionTypeEnum.PermittedDevelopment,
          displayName: "Permitted development",
          order: 4,
        },
      ];
    }
    return this.SelectLists["PlanningStatusAtStartOfDevelopment"].sort((a, b) => a.order - b.order);
  }

  GetPlanningStatusAtEndOfDevelopmentOptions(productType: ProductTypeEnum = null): ListItem[] {
    if (productType == ProductTypeEnum.Development) {
      if (this.SelectLists == null || this.SelectLists["PlanningPermissionTypeEnumDevFinance"] == null) {
        this.SelectLists["PlanningPermissionTypeEnumDevFinance"] = [
          {
            key: PlanningPermissionTypeEnum.NoPlanning,
            displayName: "No planning",
            order: 2,
          },
          {
            key: PlanningPermissionTypeEnum.OutlinePlanning,
            displayName: "Outline planning",
            order: 4,
          },
          {
            key: PlanningPermissionTypeEnum.DetailedPlanning,
            displayName: "Detailed planning",
            order: 1,
          },
          {
            key: PlanningPermissionTypeEnum.NoPlanningRequired,
            displayName: "No planning required",
            order: 3,
          },
        ];
      }
      return this.SelectLists["PlanningPermissionTypeEnumDevFinance"].sort((a, b) => a.order - b.order);
    } else {
      if (this.SelectLists == null || this.SelectLists["PlanningPermissionTypeEnum"] == null) {
        this.SelectLists["PlanningPermissionTypeEnum"] = [
          {
            key: PlanningPermissionTypeEnum.OutlinePlanning,
            displayName: "Outline planning",
            order: 2,
          },
          {
            key: PlanningPermissionTypeEnum.DetailedPlanning,
            displayName: "Detailed planning",
            order: 1,
          },
          {
            key: PlanningPermissionTypeEnum.PermittedDevelopment,
            displayName: "Permitted development",
            order: 3,
          },
        ];
      }
      return this.SelectLists["PlanningPermissionTypeEnum"].sort((a, b) => a.order - b.order);
    }
  }

  GetPurchasingExistingBuildingPlanningTypeOptions(showPermittedDevelopment: boolean = true): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"] == null) {
      this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"] = [
        {
          key: PlanningPermissionTypeEnum.VaryPlanningonExistingBuilding,
          displayName: "Vary planning on the existing building only",
          order: 3,
        },
        {
          key: PlanningPermissionTypeEnum.NewPlanningOnAnotherPartOfSite,
          displayName: "New planning on another part of the site (planning on existing building to stay as is)",
          order: 2,
        },
        {
          key: PlanningPermissionTypeEnum.VaryPlanningOnExistingAndNewPlanningOnAnotherPartOfSite,
          displayName: "Vary planning on the existing building & submit new planning on another part of the site",
          order: 4,
        },
        {
          key: PlanningPermissionTypeEnum.NewPlanningApplicationOrDemolishExistingBuilding,
          displayName: "New planning application / demolish existing building",
          order: 1,
        },
      ];
    }

    const permittedDevelopmentIndex = this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"]
      .map((e) => e.key)
      .indexOf(PlanningPermissionTypeEnum.PermittedDevelopment);

    if (showPermittedDevelopment && permittedDevelopmentIndex == -1) {
      this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"].push({
        key: PlanningPermissionTypeEnum.PermittedDevelopment,
        displayName: "Permitted development",
        order: 4,
      });
    } else if (!showPermittedDevelopment && permittedDevelopmentIndex > -1) {
      this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"].splice(permittedDevelopmentIndex);
    }

    return this.SelectLists["PurchasingExistingBuildingPlanningPermissionTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetCaseStatusOptions(isConnectUser: boolean = false): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["CaseStatusEnum"] == null) {
      this.SelectLists["CaseStatusEnum"] = [
        { key: CaseStatusEnum.Search, displayName: "Search", order: 1 },
        { key: CaseStatusEnum.NewCase, displayName: "New Case", order: 2 },
        {
          key: CaseStatusEnum.InProgress,
          displayName: "In Progress",
          order: 3,
        },
        {
          key: CaseStatusEnum.UnderReview,
          displayName: "Under Review",
          order: 4,
        },
        {
          key: CaseStatusEnum.ReadyToSubmit,
          displayName: "Ready To Submit",
          order: 5,
        },
        {
          key: CaseStatusEnum.SubmittedToLendersForHoT,
          displayName: "Submitted To Lenders for DIP",
          order: 6,
        },
        {
          key: CaseStatusEnum.ReadyToReSubmit,
          displayName: "Ready to Re-Submit",
          order: 7,
        },
        { key: CaseStatusEnum.Applied, displayName: "Applied", order: 8 },
        {
          key: CaseStatusEnum.CreditApproved,
          displayName: "Credit Approved",
          order: 9,
        },
        {
          key: CaseStatusEnum.WithProfessionals,
          displayName: "With Professionals",
          order: 10,
        },
        { key: CaseStatusEnum.Completed, displayName: "Completed", order: 11 },
        { key: CaseStatusEnum.Dormant, displayName: "Dormant", order: 12 },
        {
          key: CaseStatusEnum.SubmittedToLendersPendingReview,
          displayName: "Submitted To Lenders Pending Review",
          order: 13,
        },
        {
          key: CaseStatusEnum.SentToPackager,
          displayName: isConnectUser ? "Sent by AR" : "Sent to Packager",
          order: 14,
        },
      ];
    }

    return this.SelectLists["CaseStatusEnum"].sort((a, b) => a.order - b.order);
  }

  GetCaseLenderStateOptionsForLenders(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["CaseLenderStateEnumForLender"] == null) {
      this.SelectLists["CaseLenderStateEnumForLender"] = [
        { key: CaseLenderStateEnum.Received, displayName: "Case to review", order: 1 },
        { key: CaseLenderStateEnum.Offered, displayName: "DIP submitted", order: 2 },
        { key: CaseLenderStateEnum.Rejected, displayName: "Case rejected", order: 3 },
        { key: CaseLenderStateEnum.Withdrawn, displayName: "DIP withdrawn", order: 4 },
        { key: CaseLenderStateEnum.Applied, displayName: "DIP submitted and accepted", order: 5 },
        { key: CaseLenderStateEnum.Cancelled, displayName: "Application cancelled", order: 6 },
        { key: CaseLenderStateEnum.SentToPackager, displayName: "DIP submitted", order: 7 },
      ];
    }

    return this.SelectLists["CaseLenderStateEnumForLender"].sort((a, b) => a.order - b.order);
  }

  GetExitStrategy(excludeOther: boolean = true): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ExitStrategyEnum"] == null) {
      this.SelectLists["ExitStrategyEnum"] = [
        { key: ExitStrategyEnum.Sale, displayName: "Sale", order: 3 },
        { key: ExitStrategyEnum.Refinance, displayName: "Refinance", order: 2 },
        {
          key: ExitStrategyEnum.PartSalePartRefinance,
          displayName: "Part sale & part refinance",
          order: 1,
        },
        {
          key: ExitStrategyEnum.SaleOfAlternativeAsset,
          displayName: "Sale of an alternative asset",
          order: 4,
        },
      ];
    }

    const otherIndex = this.SelectLists["ExitStrategyEnum"].map((e) => e.key).indexOf(ExitStrategyEnum.Other);

    if (!excludeOther && otherIndex == -1) {
      this.SelectLists["ExitStrategyEnum"].push({
        key: ExitStrategyEnum.Other,
        displayName: "Other",
        order: 5,
      });
    } else if (excludeOther && otherIndex > -1) {
      this.SelectLists["ExitStrategyEnum"].splice(otherIndex);
    }

    return this.SelectLists["ExitStrategyEnum"].sort((a, b) => a.order - b.order);
  }

  GetExitStrategyDevFinanceOptions() {
    if (this.SelectLists == null || this.SelectLists["ExitStrategyDevFinanceEnum"] == null) {
      this.SelectLists["ExitStrategyDevFinanceEnum"] = [
        { key: ExitStrategyEnum.Sale, displayName: "Sale of units", order: 3 },
        { key: ExitStrategyEnum.Refinance, displayName: "Refinance", order: 2 },
        {
          key: ExitStrategyEnum.PartSalePartRefinance,
          displayName: "Part sale & part refinance",
          order: 1,
        },
      ];
    }

    return this.SelectLists["ExitStrategyDevFinanceEnum"].sort((a, b) => a.order - b.order);
  }

  GetOwnNewDevelopmentOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["OwnNewDevelopmentEnum"] == null) {
      this.SelectLists["OwnNewDevelopmentEnum"] = [
        {
          key: OwnNewDevelopmentEnum.OverseasLimitedCompany,
          displayName: "Overseas Limited Company",
          order: 1,
        },
        {
          key: OwnNewDevelopmentEnum.PensionFund,
          displayName: "Pension Fund",
          order: 2,
        },
        {
          key: OwnNewDevelopmentEnum.PersonalNames,
          displayName: "Personal Names",
          order: 3,
        },
        {
          key: OwnNewDevelopmentEnum.UKLimitedCompany,
          displayName: "UK Limited Company",
          order: 4,
        },
        {
          key: OwnNewDevelopmentEnum.UKLimitedLiabilityPartnership,
          displayName: "UK Limited Partnership",
          order: 5,
        },
      ];
    }
    return this.SelectLists["OwnNewDevelopmentEnum"].sort((a, b) => a.order - b.order);
  }

  GetCommercialOwnNewDevelopmentOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["CommercialOwnNewDevelopmentEnum"] == null) {
      this.SelectLists["CommercialOwnNewDevelopmentEnum"] = [
        {
          key: OwnNewDevelopmentEnum.OverseasLimitedCompany,
          displayName: "Overseas Limited Company",
          order: 1,
        },
        {
          key: OwnNewDevelopmentEnum.PensionFund,
          displayName: "Pension Fund",
          order: 2,
        },
        {
          key: OwnNewDevelopmentEnum.PersonalNames,
          displayName: "Personal Names",
          order: 3,
        },
        {
          key: OwnNewDevelopmentEnum.UKLimitedCompany,
          displayName: "UK Limited Company",
          order: 4,
        },
        {
          key: OwnNewDevelopmentEnum.UKLimitedLiabilityPartnership,
          displayName: "Limited Liability Partnership",
          order: 5,
        },
      ];
    }
    return this.SelectLists["CommercialOwnNewDevelopmentEnum"].sort((a, b) => a.order - b.order);
  }

  GetTitleOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["TitleEnum"] == null) {
      this.SelectLists["TitleEnum"] = [
        { key: TitleEnum.Mr, displayName: "Mr", order: 1 },
        { key: TitleEnum.Mrs, displayName: "Mrs", order: 2 },
        { key: TitleEnum.Miss, displayName: "Miss", order: 3 },
        { key: TitleEnum.Ms, displayName: "Ms", order: 4 },
        { key: TitleEnum.Other, displayName: "Other", order: 5 },
      ];
    }
    return this.SelectLists["TitleEnum"].sort((a, b) => a.order - b.order);
  }

  GetLoanCompletionOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["LoanCompletionTypeEnum"] == null) {
      this.SelectLists["LoanCompletionTypeEnum"] = [
        {
          key: LoanCompletionTypeEnum.AsSoonAsPossible,
          displayName: "As soon as possible",
          order: 1,
        },
        {
          key: LoanCompletionTypeEnum.JustCheckingMyOptions,
          displayName: "Just checking my options",
          order: 3,
        },
        {
          key: LoanCompletionTypeEnum.WithinNextFewWeeks,
          displayName: "Within the next few weeks",
          order: 2,
        },
      ];
    }
    return this.SelectLists["LoanCompletionTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetInterestRateType(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["InterestRateType"] == null) {
      this.SelectLists["InterestRateType"] = [
        { key: InterestRateTypeEnum.Fixed, displayName: "Fixed", order: 1 },
        {
          key: InterestRateTypeEnum.Variable,
          displayName: "Variable",
          order: 2,
        },
      ];
    }
    return this.SelectLists["InterestRateType"].sort((a, b) => a.order - b.order);
  }

  GetExistingPlanningChangeTypeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ExistingPlanningChangeTypeEnum"] == null) {
      this.SelectLists["ExistingPlanningChangeTypeEnum"] = [
        {
          key: ExistingPlanningChangeTypeEnum.EnhancedPlanningOnExistingBuilding,
          displayName: "Enhanced planning on existing building e.g extension or add another storey",
          order: 1,
        },
        {
          key: ExistingPlanningChangeTypeEnum.PermittedDevelopmentOnExistingBuilding,
          displayName: "Permitted development on the existing building e.g convert commerical to residential",
          order: 2,
        },
        {
          key: ExistingPlanningChangeTypeEnum.BrandNewPlanningApplication,
          displayName: "Brand new planning application e.g knock down existing building & rebuild",
          order: 3,
        },
      ];
    }
    return this.SelectLists["ExistingPlanningChangeTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetBuildStageOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BuildStageEnum"] == null) {
      this.SelectLists["BuildStageEnum"] = [
        {
          key: BuildStageEnum.PracticalCompletion,
          displayName: "Practical Completion",
          order: 1,
        },
        {
          key: BuildStageEnum.WindAndWaterTight,
          displayName: "Wind & Water Tight",
          order: 2,
        },
        {
          key: BuildStageEnum.PreWindAndWaterTight,
          displayName: "Pre Wind And Water Tight",
          order: 3,
        },
      ];
    }
    return this.SelectLists["BuildStageEnum"].sort((a, b) => a.order - b.order);
  }

  GetOwnershipRoleOptions(productType: ProductTypeEnum = ProductTypeEnum.None): ListItem[] {
    // if (this.SelectLists == null || this.SelectLists['OwnerShipRoleEnum'] == null) {
    this.SelectLists["OwnerShipRoleEnum"] = [
      { key: OwnershipRoleEnum.Director, displayName: "Director", order: 1 },
      {
        key: OwnershipRoleEnum.DirectorAndShareholder,
        displayName: "Director & Shareholder",
        order: 3,
      },
      {
        key: OwnershipRoleEnum.Shareholder,
        displayName: "Shareholder",
        order: 2,
      },
    ];

    if (productType == ProductTypeEnum.CommercialOwnerOccupied) {
      this.SelectLists["OwnerShipRoleEnum"].push({
        key: OwnershipRoleEnum.Member,
        displayName: "Member",
        order: 4,
      });
      this.SelectLists["OwnerShipRoleEnum"].push({
        key: OwnershipRoleEnum.Partner,
        displayName: "Partner",
        order: 5,
      });
    }
    //}
    return this.SelectLists["OwnerShipRoleEnum"].sort((a, b) => a.order - b.order);
  }

  GetRefurbishmentLevelOptions(includeNone: boolean = false): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["RefurbishmentLevelEnum"] == null) {
      this.SelectLists["RefurbishmentLevelEnum"] = [
        { key: RefurbishmentLevelEnum.Light, displayName: "Light", order: 1 },
        { key: RefurbishmentLevelEnum.Medium, displayName: "Medium", order: 2 },
        { key: RefurbishmentLevelEnum.Heavy, displayName: "Heavy", order: 3 },
      ];
    }

    const noneIndex = this.SelectLists["RefurbishmentLevelEnum"].map((e) => e.key).indexOf(RefurbishmentLevelEnum.None);

    if (includeNone && noneIndex == -1) {
      this.SelectLists["RefurbishmentLevelEnum"].push({
        key: RefurbishmentLevelEnum.None,
        displayName: "None",
        order: 0,
      });
    } else if (!includeNone && noneIndex > -1) {
      this.SelectLists["RefurbishmentLevelEnum"].splice(noneIndex);
    }

    return this.SelectLists["RefurbishmentLevelEnum"].sort((a, b) => a.order - b.order);
  }

  GetPropertyTypes(productType = ProductTypeEnum.CommercialInvestment): ListItem[] {
    const baseItems: ListItem[] = [
      {
        key: PropertyTypeEnum.MixedUse,
        displayName: "Mixed Use (part residential, part commercial)",
        order: 2,
      },
      {
        key: PropertyTypeEnum.AllCommercialMixedUse,
        displayName: "Mixed Use (all commercial)",
        order: 3,
      },
    ];

    if (productType != ProductTypeEnum.CommercialInvestment && productType != ProductTypeEnum.CommercialOwnerOccupied) {
      baseItems.push({
        key: PropertyTypeEnum.Residential,
        displayName: "Pure Residential",
        order: 1,
      });
    }

    if (productType != ProductTypeEnum.CommercialOwnerOccupied) {
      baseItems.push(
        {
          key: PropertyTypeEnum.HMO,
          displayName: "Licenced HMO",
          order: 4,
        },
        {
          key: PropertyTypeEnum.MultiUnitFreeholdBlock,
          displayName: "Multi-Unit Freehold Block",
          order: 5,
        },
      );
    }

    baseItems.sort((a, b) => a.order - b.order);

    // Divider
    const divider: ListItem = {
      key: null,
      displayName: "──────────",
      isDivider: true,
    };

    // Group label
    const commercialGroupLabel: ListItem = {
      key: null,
      displayName: "Commercial",
      isGroupLabel: true,
    };

    // Commercial types to go under group
    const commercialTypes = [
      {
        key: PropertyTypeEnum.Agricultural,
        displayName: "\u00A0\u00A0\u00A0\u00A0Agricultural (inc. trading farms & horticulture)",
      },
      { key: PropertyTypeEnum.Airport, displayName: "\u00A0\u00A0\u00A0\u00A0Airport" },
      { key: PropertyTypeEnum.BarAndNightclub, displayName: "\u00A0\u00A0\u00A0\u00A0Bar & Nightclub" },
      { key: PropertyTypeEnum.CareRetirement, displayName: "\u00A0\u00A0\u00A0\u00A0Care Home" },
      { key: PropertyTypeEnum.ChildrensDayNursery, displayName: "\u00A0\u00A0\u00A0\u00A0Children's Day Nursery" },
      {
        key: PropertyTypeEnum.Education,
        displayName: "\u00A0\u00A0\u00A0\u00A0Educational (inc. schools, pre-schools)",
      },
      {
        key: PropertyTypeEnum.EntertainmentVenue,
        displayName: "\u00A0\u00A0\u00A0\u00A0Entertainment Venue (inc. cinemas & theatres)",
      },
      { key: PropertyTypeEnum.Equestrian, displayName: "\u00A0\u00A0\u00A0\u00A0Equestrian" },
      {
        key: PropertyTypeEnum.ExIndustrialSpace,
        displayName: "\u00A0\u00A0\u00A0\u00A0Ex-Industrial Space (inc. coal mines & steel works)",
      },
      { key: PropertyTypeEnum.GolfCourse, displayName: "\u00A0\u00A0\u00A0\u00A0Golf Course" },
      { key: PropertyTypeEnum.GymLeisureCentre, displayName: "\u00A0\u00A0\u00A0\u00A0Gym / Leisure Centre" },
      { key: PropertyTypeEnum.HeavyIndustrial, displayName: "\u00A0\u00A0\u00A0\u00A0Heavy Industry" },
      {
        key: PropertyTypeEnum.HolidayPark,
        displayName: "\u00A0\u00A0\u00A0\u00A0Holiday Park (inc. caravan & holiday parks)",
      },
      { key: PropertyTypeEnum.Hotel, displayName: "\u00A0\u00A0\u00A0\u00A0Hotel" },
      { key: PropertyTypeEnum.Leisure, displayName: "\u00A0\u00A0\u00A0\u00A0Leisure" },
      { key: PropertyTypeEnum.LightIndustrial, displayName: "\u00A0\u00A0\u00A0\u00A0Light Industry" },
      { key: PropertyTypeEnum.Medical, displayName: "\u00A0\u00A0\u00A0\u00A0Medical (inc. doctors, dentists)" },
      { key: PropertyTypeEnum.Museum, displayName: "\u00A0\u00A0\u00A0\u00A0Museum" },
      { key: PropertyTypeEnum.Office, displayName: "\u00A0\u00A0\u00A0\u00A0Office" },
      { key: PropertyTypeEnum.PlaceOfWorship, displayName: "\u00A0\u00A0\u00A0\u00A0Place of Worship" },
      { key: PropertyTypeEnum.PubOrRestaurant, displayName: "\u00A0\u00A0\u00A0\u00A0Pub / Restaurant" },
      { key: PropertyTypeEnum.Retail, displayName: "\u00A0\u00A0\u00A0\u00A0Retail" },
      { key: PropertyTypeEnum.Retirement, displayName: "\u00A0\u00A0\u00A0\u00A0Retirement (age restricted)" },
      { key: PropertyTypeEnum.Student, displayName: "\u00A0\u00A0\u00A0\u00A0Student (inc. PBSA)" },
      { key: PropertyTypeEnum.Supermarket, displayName: "\u00A0\u00A0\u00A0\u00A0Supermarket" },
      { key: PropertyTypeEnum.TakeawayRestaurant, displayName: "\u00A0\u00A0\u00A0\u00A0Takeaway Restaurant" },
      { key: PropertyTypeEnum.ThemePark, displayName: "\u00A0\u00A0\u00A0\u00A0Theme Park" },
      {
        key: PropertyTypeEnum.TransportHub,
        displayName: "\u00A0\u00A0\u00A0\u00A0Transport Hub (inc. railway & bus stations)",
      },
    ].sort((a, b) => a.displayName.localeCompare(b.displayName));

    this.SelectLists["PropertyTypeEnum"] = [...baseItems, divider, commercialGroupLabel, ...commercialTypes];

    return this.SelectLists["PropertyTypeEnum"];
  }

  GetLoanRepaymentTypeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["LoanRepaymentTypeEnum"] == null) {
      this.SelectLists["LoanRepaymentTypeEnum"] = [
        {
          key: LoanRepaymentTypeEnum.InterestOnly,
          displayName: "Interest only",
          order: 2,
        },
        {
          key: LoanRepaymentTypeEnum.Repayment,
          displayName: "Capital & Interest",
          order: 1,
        },
      ];
    }

    return this.SelectLists["LoanRepaymentTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetFixedRateTermOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["FixedRateTermEnum"] == null) {
      this.SelectLists["FixedRateTermEnum"] = [
        { key: FixedRateTermEnum.TwoYear, displayName: "2 Year", order: 1 },
        { key: FixedRateTermEnum.ThreeYear, displayName: "3 Year", order: 2 },
        { key: FixedRateTermEnum.FiveYear, displayName: "5 Year", order: 3 },
        { key: FixedRateTermEnum.SevenYear, displayName: "7 Year", order: 4 },
        { key: FixedRateTermEnum.TenYear, displayName: "10 Year", order: 5 },
        { key: FixedRateTermEnum.FifteenYear, displayName: "15 Year", order: 6 },
      ];
    }

    return this.SelectLists["FixedRateTermEnum"].sort((a, b) => a.order - b.order);
  }

  GetTimeLeftOnLeaseOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["TimeLeftOnLeaseEnum"] == null) {
      this.SelectLists["TimeLeftOnLeaseEnum"] = [
        {
          key: TimeLeftOnLeaseEnum.LessThanYear,
          displayName: "Less than Year",
          order: 1,
        },
        {
          key: TimeLeftOnLeaseEnum.OneToThreeYears,
          displayName: "1 - 3 Years",
          order: 2,
        },
        {
          key: TimeLeftOnLeaseEnum.MoreThanThreeYears,
          displayName: "More than 3 Years",
          order: 3,
        },
      ];
    }

    return this.SelectLists["TimeLeftOnLeaseEnum"].sort((a, b) => a.order - b.order);
  }

  GetLinkTypeOptions(showBridging: boolean = false, showCommercial: boolean = false): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["LinkTypeEnum"] == null) {
      this.SelectLists["LinkTypeEnum"] = [
        {
          key: LinkTypeEnum.Development,
          displayName: "Development Finance",
          order: 4,
        },
        { key: LinkTypeEnum.Bridging, displayName: "Bridging", order: 2 },
        { key: LinkTypeEnum.AllLoans, displayName: "All Loans", order: 1 },
        {
          key: LinkTypeEnum.Commercial,
          displayName: "Commercial Mortgage",
          order: 3,
        },
      ];
    }

    const bridgingIndex = this.SelectLists["LinkTypeEnum"].map((e) => e.key).indexOf(LinkTypeEnum.Bridging);

    if (showBridging && bridgingIndex == -1) {
      this.SelectLists["LinkTypeEnum"].push({
        key: LinkTypeEnum.Bridging,
        displayName: "Bridging",
        order: 2,
      });
    } else if (!showBridging && bridgingIndex > -1) {
      this.SelectLists["LinkTypeEnum"].splice(bridgingIndex);
    }

    const commercialIndex = this.SelectLists["LinkTypeEnum"].map((e) => e.key).indexOf(LinkTypeEnum.Commercial);

    if (showCommercial && commercialIndex == -1) {
      this.SelectLists["LinkTypeEnum"].push({
        key: LinkTypeEnum.Commercial,
        displayName: "Commercial Mortgage",
        order: 4,
      });
    } else if (!showCommercial && commercialIndex > -1) {
      this.SelectLists["LinkTypeEnum"].splice(commercialIndex);
    }

    return this.SelectLists["LinkTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetCountries() {
    const countrylist = [
      "United Kingdom of Great Britain and Northern Ireland (the)",
      "Afghanistan",
      "Albania",
      "Algeria",
      "American Samoa",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antarctica",
      "Antigua and Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas (the)",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia (Plurinational State of)",
      "Bonaire, Sint Eustatius and Saba",
      "Bosnia and Herzegovina",
      "Botswana",
      "Bouvet Island",
      "Brazil",
      "British Indian Ocean Territory (the)",
      "Brunei Darussalam",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cabo Verde",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cayman Islands (the)",
      "Central African Republic (the)",
      "Chad",
      "Chile",
      "China",
      "Christmas Island",
      "Cocos (Keeling) Islands (the)",
      "Colombia",
      "Comoros (the)",
      "Congo (the Democratic Republic of the)",
      "Congo (the)",
      "Cook Islands (the)",
      "Costa Rica",
      "Croatia",
      "Cuba",
      "Curaçao",
      "Cyprus",
      "Czechia",
      "Côte d'Ivoire",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic (the)",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Eritrea",
      "Estonia",
      "Eswatini",
      "Ethiopia",
      "Falkland Islands (the) [Malvinas]",
      "Faroe Islands (the)",
      "Fiji",
      "Finland",
      "France",
      "French Guiana",
      "French Polynesia",
      "French Southern Territories (the)",
      "Gabon",
      "Gambia (the)",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guadeloupe",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea-Bissau",
      "Guyana",
      "Haiti",
      "Heard Island and McDonald Islands",
      "Holy See (the)",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran (Islamic Republic of)",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kiribati",
      "Korea (the Democratic People's Republic of)",
      "Korea (the Republic of)",
      "Kuwait",
      "Kyrgyzstan",
      "Lao People's Democratic Republic (the)",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macao",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Marshall Islands (the)",
      "Martinique",
      "Mauritania",
      "Mauritius",
      "Mayotte",
      "Mexico",
      "Micronesia (Federated States of)",
      "Moldova (the Republic of)",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Myanmar",
      "Namibia",
      "Nauru",
      "Nepal",
      "Netherlands (the)",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger (the)",
      "Nigeria",
      "Niue",
      "Norfolk Island",
      "Northern Mariana Islands (the)",
      "Norway",
      "Oman",
      "Pakistan",
      "Palau",
      "Palestine, State of",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines (the)",
      "Pitcairn",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Republic of North Macedonia",
      "Romania",
      "Russian Federation (the)",
      "Rwanda",
      "Réunion",
      "Saint Barthélemy",
      "Saint Helena, Ascension and Tristan da Cunha",
      "Saint Kitts and Nevis",
      "Saint Lucia",
      "Saint Martin (French part)",
      "Saint Pierre and Miquelon",
      "Saint Vincent and the Grenadines",
      "Samoa",
      "San Marino",
      "Sao Tome and Principe",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Sint Maarten (Dutch part)",
      "Slovakia",
      "Slovenia",
      "Solomon Islands",
      "Somalia",
      "South Africa",
      "South Georgia and the South Sandwich Islands",
      "South Sudan",
      "Spain",
      "Sri Lanka",
      "Sudan (the)",
      "Suriname",
      "Svalbard and Jan Mayen",
      "Sweden",
      "Switzerland",
      "Syrian Arab Republic",
      "Taiwan",
      "Tajikistan",
      "Tanzania, United Republic of",
      "Thailand",
      "Timor-Leste",
      "Togo",
      "Tokelau",
      "Tonga",
      "Trinidad and Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks and Caicos Islands (the)",
      "Tuvalu",
      "Uganda",
      "Ukraine",
      "United Arab Emirates (the)",
      "United States Minor Outlying Islands (the)",
      "United States of America (the)",
      "Uruguay",
      "Uzbekistan",
      "Vanuatu",
      "Venezuela (Bolivarian Republic of)",
      "Viet Nam",
      "Virgin Islands (British)",
      "Virgin Islands (U.S.)",
      "Wallis and Futuna",
      "Western Sahara",
      "Yemen",
      "Zambia",
      "Zimbabwe",
      "Åland Islands",
    ];
    return countrylist;
  }

  GetNationalities() {
    const nationalityList = [
      "British",
      "Afghan",
      "Albanian",
      "Algerian",
      "American",
      "Andorran",
      "Angolan",
      "Anguillan",
      "Argentine",
      "Armenian",
      "Australian",
      "Austrian",
      "Azerbaijani",
      "Bahamian",
      "Bahraini",
      "Bangladeshi",
      "Barbadian",
      "Belarusian",
      "Belgian",
      "Belizean",
      "Beninese",
      "Bermudian",
      "Bhutanese",
      "Bolivian",
      "Botswanan",
      "Brazilian",
      "British Virgin Islander",
      "Bruneian",
      "Bulgarian",
      "Burkinan",
      "Burmese",
      "Burundian",
      "Cambodian",
      "Cameroonian",
      "Canadian",
      "Cape Verdean",
      "Cayman Islander",
      "Central African",
      "Chadian",
      "Chilean",
      "Chinese",
      "Citizen of Antigua and Barbuda",
      "Citizen of Bosnia and Herzegovina",
      "Citizen of Guinea-Bissau",
      "Citizen of Kiribati",
      "Citizen of Seychelles",
      "Citizen of the Dominican Republic",
      "Citizen of Vanuatu ",
      "Colombian",
      "Comoran",
      "Congolese (Congo)",
      "Congolese (DRC)",
      "Cook Islander",
      "Costa Rican",
      "Croatian",
      "Cuban",
      "Cymraes",
      "Cymro",
      "Cypriot",
      "Czech",
      "Danish",
      "Djiboutian",
      "Dominican",
      "Dutch",
      "East Timorese",
      "Ecuadorean",
      "Egyptian",
      "Emirati",
      "English",
      "Equatorial Guinean",
      "Eritrean",
      "Estonian",
      "Ethiopian",
      "Faroese",
      "Fijian",
      "Filipino",
      "Finnish",
      "French",
      "Gabonese",
      "Gambian",
      "Georgian",
      "German",
      "Ghanaian",
      "Gibraltarian",
      "Greek",
      "Greenlandic",
      "Grenadian",
      "Guamanian",
      "Guatemalan",
      "Guinean",
      "Guyanese",
      "Haitian",
      "Honduran",
      "Hong Konger",
      "Hungarian",
      "Icelandic",
      "Indian",
      "Indonesian",
      "Iranian",
      "Iraqi",
      "Irish",
      "Israeli",
      "Italian",
      "Ivorian",
      "Jamaican",
      "Japanese",
      "Jordanian",
      "Kazakh",
      "Kenyan",
      "Kittitian",
      "Kosovan",
      "Kuwaiti",
      "Kyrgyz",
      "Lao",
      "Latvian",
      "Lebanese",
      "Liberian",
      "Libyan",
      "Liechtenstein citizen",
      "Lithuanian",
      "Luxembourger",
      "Macanese",
      "Macedonian",
      "Malagasy",
      "Malawian",
      "Malaysian",
      "Maldivian",
      "Malian",
      "Maltese",
      "Marshallese",
      "Martiniquais",
      "Mauritanian",
      "Mauritian",
      "Mexican",
      "Micronesian",
      "Moldovan",
      "Monegasque",
      "Mongolian",
      "Montenegrin",
      "Montserratian",
      "Moroccan",
      "Mosotho",
      "Mozambican",
      "Namibian",
      "Nauruan",
      "Nepalese",
      "New Zealander",
      "Nicaraguan",
      "Nigerian",
      "Nigerien",
      "Niuean",
      "North Korean",
      "Northern Irish",
      "Norwegian",
      "Omani",
      "Pakistani",
      "Palauan",
      "Palestinian",
      "Panamanian",
      "Papua New Guinean",
      "Paraguayan",
      "Peruvian",
      "Pitcairn Islander",
      "Polish",
      "Portuguese",
      "Prydeinig",
      "Puerto Rican",
      "Qatari",
      "Romanian",
      "Russian",
      "Rwandan",
      "Salvadorean",
      "Sammarinese",
      "Samoan",
      "Sao Tomean",
      "Saudi Arabian",
      "Scottish",
      "Senegalese",
      "Serbian",
      "Sierra Leonean",
      "Singaporean",
      "Slovak",
      "Slovenian",
      "Solomon Islander",
      "Somali",
      "South African",
      "South Korean",
      "South Sudanese",
      "Spanish",
      "Sri Lankan",
      "St Helenian",
      "St Lucian",
      "Stateless",
      "Sudanese",
      "Surinamese",
      "Swazi",
      "Swedish",
      "Swiss",
      "Syrian",
      "Taiwanese",
      "Tajik",
      "Tanzanian",
      "Thai",
      "Togolese",
      "Tongan",
      "Trinidadian",
      "Tristanian",
      "Tunisian",
      "Turkish",
      "Turkmen",
      "Turks and Caicos Islander",
      "Tuvaluan",
      "Ugandan",
      "Ukrainian",
      "Uruguayan",
      "Uzbek",
      "Vatican citizen",
      "Venezuelan",
      "Vietnamese",
      "Vincentian",
      "Wallisian",
      "Welsh",
      "Yemeni",
      "Zambian",
      "Zimbabwean",
    ];

    return nationalityList;
  }

  GetBorrowingEntityTypeOptions(productType: ProductTypeEnum = ProductTypeEnum.None): ListItem[] {
    if (productType == ProductTypeEnum.CommercialOwnerOccupied) {
      this.SelectLists["BorrowingEntityTypeEnum"] = [
        {
          key: BorrowingEntityTypeEnum.Company,
          displayName: "Limited Co",
          order: 1,
        },
        {
          key: BorrowingEntityTypeEnum.SoleTrader,
          displayName: "Sole Trader",
          order: 6,
        },
        {
          key: BorrowingEntityTypeEnum.Partnership,
          displayName: "Partnership",
          order: 4,
        },
        { key: BorrowingEntityTypeEnum.LLP, displayName: "LLP", order: 2 },
        {
          key: BorrowingEntityTypeEnum.Trust,
          displayName: "Trust",
          order: 7,
        },
        {
          key: BorrowingEntityTypeEnum.SIPPOrSSAS,
          displayName: "SIPP / SSAS",
          order: 5,
        },
        {
          key: BorrowingEntityTypeEnum.OverseasCo,
          displayName: "Overseas Co",
          order: 3,
        },
      ];
    } else {
      this.SelectLists["BorrowingEntityTypeEnum"] = [
        {
          key: BorrowingEntityTypeEnum.Company,
          displayName: "Company",
          order: 1,
        },
        {
          key: BorrowingEntityTypeEnum.Individual,
          displayName: "Individual",
          order: 2,
        },
      ];
    }

    return this.SelectLists["BorrowingEntityTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetMaxIndividualUnitPrices(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaxIndividualUnitPriceEnum"] == null) {
      this.SelectLists["MaxIndividualUnitPriceEnum"] = [
        {
          key: MaxIndividualUnitPriceEnum.NoMax,
          displayName: "Above £5m",
          order: 5,
        },
        {
          key: MaxIndividualUnitPriceEnum.UpTo1Million,
          displayName: "Up to £1m",
          order: 2,
        },
        {
          key: MaxIndividualUnitPriceEnum.UpTo2Million,
          displayName: "Up to £2m",
          order: 3,
        },
        {
          key: MaxIndividualUnitPriceEnum.UpTo5Million,
          displayName: "Up to £5m",
          order: 4,
        },
      ];
    }
    return this.SelectLists["MaxIndividualUnitPriceEnum"].sort((a, b) => a.order - b.order);
  }

  GetAcceptableEPCRating(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["EPCRatingTypeEnum"] == null) {
      this.SelectLists["EPCRatingTypeEnum"] = [
        { key: EPCRatingTypeEnum.AtoC, displayName: "A - C rating", order: 1 },
        { key: EPCRatingTypeEnum.DtoE, displayName: "D - E rating", order: 2 },
        { key: EPCRatingTypeEnum.AboveE, displayName: "F+ rating", order: 3 },
      ];
    }
    return this.SelectLists["EPCRatingTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetEWS1GradeType(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["EWS1GradeTypeEnum"] == null) {
      this.SelectLists["EWS1GradeTypeEnum"] = [
        { key: EWS1GradeTypeEnum.A, displayName: "A rating", order: 1 },
        { key: EWS1GradeTypeEnum.B, displayName: "B rating", order: 2 },
      ];
    }
    return this.SelectLists["EWS1GradeTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetEPCRating(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["EPCRatingTypeEnum"] == null) {
      this.SelectLists["EPCRatingTypeEnum"] = [
        { key: EPCRatingTypeEnum.A, displayName: "A", order: 1 },
        { key: EPCRatingTypeEnum.B, displayName: "B", order: 2 },
        { key: EPCRatingTypeEnum.C, displayName: "C", order: 3 },
        { key: EPCRatingTypeEnum.D, displayName: "D", order: 4 },
        { key: EPCRatingTypeEnum.E, displayName: "E", order: 5 },
        { key: EPCRatingTypeEnum.AboveE, displayName: "Above E", order: 6 },
      ];
    }
    return this.SelectLists["EPCRatingTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetLocations(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["LocationEnum"] == null) {
      this.SelectLists["LocationEnum"] = [
        {
          key: LocationEnum.ChannelIsland,
          displayName: "Channel Islands",
          order: 1,
        },
        {
          key: LocationEnum.EastofEngland,
          displayName: "East of England",
          order: 2,
        },
        { key: LocationEnum.London, displayName: "London", order: 3 },
        { key: LocationEnum.Midlands, displayName: "Midlands", order: 4 },
        { key: LocationEnum.NorthEast, displayName: "North East", order: 5 },
        { key: LocationEnum.NorthWest, displayName: "North West", order: 6 },
        {
          key: LocationEnum.NorthernIreland,
          displayName: "Northern Ireland",
          order: 7,
        },
        { key: LocationEnum.Scotland, displayName: "Scotland", order: 8 },
        { key: LocationEnum.SouthEast, displayName: "South East", order: 9 },
        { key: LocationEnum.SouthWest, displayName: "South West", order: 10 },
        { key: LocationEnum.Wales, displayName: "Wales", order: 11 },
      ];
    }
    return this.SelectLists["LocationEnum"].sort((a, b) => a.order - b.order);
  }

  GetPlanningResponsibilityOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PlanningResponsibilityEnum"] == null) {
      this.SelectLists["PlanningResponsibilityEnum"] = [
        {
          key: PlanningResponsibilityEnum.Borrower,
          displayName: "Borrower",
          order: 1,
        },
        {
          key: PlanningResponsibilityEnum.PreviousOwner,
          displayName: "Previous owner",
          order: 2,
        },
        {
          key: PlanningResponsibilityEnum.SomebodyElse,
          displayName: "Someone else",
          order: 3,
        },
        { key: PlanningResponsibilityEnum.NA, displayName: "N/A", order: 4 },
      ];
    }
    return this.SelectLists["PlanningResponsibilityEnum"].sort((a, b) => a.order - b.order);
  }

  GetBuildProcurementTypeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BuildProcurementTypeEnum"] == null) {
      this.SelectLists["BuildProcurementTypeEnum"] = [
        {
          key: BuildProcurementTypeEnum.DesignAndBuildContract,
          displayName: "Design and build contract",
          order: 1,
        },
        {
          key: BuildProcurementTypeEnum.TraditionalContract,
          displayName: "Traditional contract (separate design & build)",
          order: 3,
        },
        {
          key: BuildProcurementTypeEnum.SelfManaged,
          displayName: "Self-managed procurement (borrowers will manage the individual trade packages)",
          order: 2,
        },
      ];
    }
    return this.SelectLists["BuildProcurementTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetSceheduleTenureTypes(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["SceheduleTenureEnum"] == null) {
      this.SelectLists["SceheduleTenureEnum"] = [
        { key: TenureEnum.Freehold, displayName: "Freehold", order: 1 },
        { key: TenureEnum.Leasehold, displayName: "Leasehold", order: 2 },
        { key: TenureEnum.Other, displayName: "Other", order: 3 },
      ];
    }

    return this.SelectLists["SceheduleTenureEnum"].sort((a, b) => a.order - b.order);
  }

  GetPreAgreementTypes(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PreAgreementEnum"] == null) {
      this.SelectLists["PreAgreementEnum"] = [
        { key: PreAgreementEnum.PreLet, displayName: "Pre-Let", order: 1 },
        { key: PreAgreementEnum.PreSold, displayName: "Pre-Sold", order: 2 },
        { key: PreAgreementEnum.None, displayName: "None", order: 3 },
      ];
    }

    return this.SelectLists["PreAgreementEnum"].sort((a, b) => a.order - b.order);
  }

  GetHouseDescriptionTypes(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["HouseDescriptionTypeEnum"] == null) {
      this.SelectLists["HouseDescriptionTypeEnum"] = [
        {
          key: ScheduleDescriptionTypeEnum.Bungalow,
          displayName: "Bungalow",
          order: 1,
        },
        {
          key: ScheduleDescriptionTypeEnum.Cottage,
          displayName: "Cottage",
          order: 2,
        },
        {
          key: ScheduleDescriptionTypeEnum.DetachedHouse,
          displayName: "Detached house",
          order: 3,
        },
        {
          key: ScheduleDescriptionTypeEnum.SemiDetachedHouse,
          displayName: "Semi-detached house",
          order: 4,
        },
        {
          key: ScheduleDescriptionTypeEnum.TerrancedHouse,
          displayName: "Terranced house",
          order: 5,
        },
      ];
    }

    return this.SelectLists["HouseDescriptionTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetFlatDescriptionTypes(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["FlatDescriptionTypeEnum"] == null) {
      this.SelectLists["FlatDescriptionTypeEnum"] = [
        {
          key: ScheduleDescriptionTypeEnum.Studio,
          displayName: "Studio",
          order: 1,
        },
        {
          key: ScheduleDescriptionTypeEnum.SingleStorey,
          displayName: "Single storey",
          order: 2,
        },
        {
          key: ScheduleDescriptionTypeEnum.Duplex,
          displayName: "Duplex",
          order: 3,
        },
        {
          key: ScheduleDescriptionTypeEnum.Triplex,
          displayName: "Triplex",
          order: 4,
        },
      ];
    }

    return this.SelectLists["FlatDescriptionTypeEnum"].sort((a, b) => a.order - b.order);
  }

  GetTradingPeriodTypes(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["TradingPeriod"] == null) {
      this.SelectLists["TradingPeriod"] = [
        {
          key: TradingPeriodEnum.LessThanTwoYears,
          displayName: "< 2 Years",
          order: 1,
        },
        {
          key: TradingPeriodEnum.MoreThanTwoYears,
          displayName: "2 Years +",
          order: 2,
        },
      ];
    }

    return this.SelectLists["TradingPeriod"].sort((a, b) => a.order - b.order);
  }

  GetPlanningPermissionTypesOfBridging(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["PlanningPermissionTypesOfBridging"] == null) {
      this.SelectLists["PlanningPermissionTypesOfBridging"] = [
        {
          key: PlanningPermissionTypeEnum.NoPlanning,
          displayName: "No planning",
          order: 2,
        },
        {
          key: PlanningPermissionTypeEnum.OutlinePlanning,
          displayName: "Outline planning",
          order: 3,
        },
        {
          key: PlanningPermissionTypeEnum.DetailedPlanning,
          displayName: "Detailed planning",
          order: 1,
        },
      ];
    }
    return this.SelectLists["PlanningPermissionTypesOfBridging"].sort((a, b) => a.order - b.order);
  }

  GetValuationMethodOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["ValuationMethodEnum"] == null) {
      this.SelectLists["ValuationMethodEnum"] = [
        {
          key: ValuationMethodEnum.OMV,
          displayName: "OMV",
          order: 4,
        },
        {
          key: ValuationMethodEnum.One80DayVP,
          displayName: "180 day VP",
          order: 1,
        },
        {
          key: ValuationMethodEnum.NinetyDayVP,
          displayName: "90 day VP",
          order: 2,
        },
        {
          key: ValuationMethodEnum.CommercialValuation,
          displayName: "Commercial Valuation",
          order: 3,
        },
      ];
    }

    return this.SelectLists["ValuationMethodEnum"].sort((a, b) => a.order - b.order);
  }

  GetMaxCommercialFloorspaceOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["MaxCommercialFloorspaceEnum"] == null) {
      this.SelectLists["MaxCommercialFloorspaceEnum"] = [
        {
          key: MaxCommercialFloorspaceEnum.Below50,
          displayName: "0 - 50%",
          order: 1,
        },
        {
          key: MaxCommercialFloorspaceEnum.FiftyOneTo75,
          displayName: "51 - 75%",
          order: 2,
        },
        {
          key: MaxCommercialFloorspaceEnum.Above76,
          displayName: "Above 76%",
          order: 3,
        },
      ];
    }
    return this.SelectLists["MaxCommercialFloorspaceEnum"].sort((a, b) => a.order - b.order);
  }

  GetNonPhysicalValuationOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["NonPhysicalValuationEnum"] == null) {
      this.SelectLists["NonPhysicalValuationEnum"] = [
        {
          key: NonPhysicalValuationEnum.AVM,
          displayName: "AVM",
          order: 1,
        },
        {
          key: NonPhysicalValuationEnum.DesktopValuation,
          displayName: "Desktop Valuation",
          order: 2,
        },
      ];
    }
    return this.SelectLists["NonPhysicalValuationEnum"].sort((a, b) => a.order - b.order);
  }

  GetCRMs(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["CRMEnum"] == null) {
      this.SelectLists["CRMEnum"] = [
        { key: CRMEnum.OMS, displayName: "OMS", order: 1 },
        { key: CRMEnum.Finova, displayName: "Finova", order: 2 },
        { key: CRMEnum.BATSoftware, displayName: "BAT Software", order: 3 },
        { key: CRMEnum.Acre, displayName: "Acre", order: 4 },
        { key: CRMEnum.Smart365, displayName: "Smart365", order: 5 },
        { key: CRMEnum.Salesforce, displayName: "Salesforce", order: 6 },
        { key: CRMEnum.Pipedrive, displayName: "Pipedrive", order: 7 },
        { key: CRMEnum.Zoho, displayName: "Zoho", order: 8 },
        { key: CRMEnum.HubSpot, displayName: "HubSpot", order: 9 },
        { key: CRMEnum.EKeeper, displayName: "EKeeper", order: 10 },
        { key: CRMEnum.XPlan, displayName: "XPlan", order: 11 },
        { key: CRMEnum.TheKey, displayName: "The Key", order: 12 },
        { key: CRMEnum.Other, displayName: "Other", order: 12 },
      ];
    }

    // Sorts alphabetically but pins "Other" to the end
    const collator = new Intl.Collator("en-GB", { sensitivity: "base" });
    return this.SelectLists["CRMEnum"].slice().sort((a, b) => {
      const aIsOther = a.key === CRMEnum.Other;
      const bIsOther = b.key === CRMEnum.Other;
      if (aIsOther && !bIsOther) return 1; // push a to the end
      if (!aIsOther && bIsOther) return -1; // push b to the end
      return collator.compare(a.displayName, b.displayName);
    });
  }

  GetBrokerNetworks(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BrokerNetworkEnum"] == null) {
      this.SelectLists["BrokerNetworkEnum"] = [
        { key: BrokerNetworkEnum.ConnectIFA, displayName: "Connect IFA", order: 1 },
        { key: BrokerNetworkEnum.Synergy, displayName: "Synergy", order: 2 },
        {
          key: BrokerNetworkEnum.NewLeafDistribution,
          displayName: "New Leaf Distribution",
          order: 3,
        },
        { key: BrokerNetworkEnum.Fiducia, displayName: "Fiducia", order: 4 },
        {
          key: BrokerNetworkEnum.RosemountFinancialSolutions,
          displayName: "Rosemount Financial Solutions",
          order: 5,
        },
        { key: BrokerNetworkEnum.StJamesPlace, displayName: "St James Place", order: 6 },
        { key: BrokerNetworkEnum.Primis, displayName: "Primis", order: 7 },
        { key: BrokerNetworkEnum.Quilter, displayName: "Quilter", order: 8 },
        { key: BrokerNetworkEnum.Stonebridge, displayName: "Stonebridge", order: 9 },
        { key: BrokerNetworkEnum.Openwork, displayName: "Openwork", order: 10 },
        { key: BrokerNetworkEnum.HLPartnership, displayName: "HL Partnership", order: 11 },
        {
          key: BrokerNetworkEnum.TheRightMortgageLimited,
          displayName: "The Right Mortgage Limited",
          order: 12,
        },
        {
          key: BrokerNetworkEnum.PlanWealthManagement,
          displayName: "Plan Wealth Management",
          order: 13,
        },
        { key: BrokerNetworkEnum.Sesame, displayName: "Sesame", order: 14 },
        {
          key: BrokerNetworkEnum.TheOnLinePartnershipLtd,
          displayName: "The On-Line Partnership Ltd",
          order: 15,
        },
        {
          key: BrokerNetworkEnum.MortgageAdviceBureau,
          displayName: "Mortgage Advice Bureau",
          order: 16,
        },
        { key: BrokerNetworkEnum.SenseNetwork, displayName: "Sense Network", order: 17 },
        {
          key: BrokerNetworkEnum.MortgageIntelligenceLtd,
          displayName: "Mortgage Intelligence Ltd",
          order: 18,
        },
        { key: BrokerNetworkEnum.ValidPathLimited, displayName: "ValidPath Limited", order: 19 },
        {
          key: BrokerNetworkEnum.BestPracticeIFAGroupLimited,
          displayName: "Best Practice IFA Group Limited",
          order: 20,
        },
        {
          key: BrokerNetworkEnum.WhiteRoseFinanceGroupLimited,
          displayName: "White Rose Finance Group Limited",
          order: 21,
        },
        { key: BrokerNetworkEnum.TMGDirectLimited, displayName: "TMG Direct Limited", order: 22 },
        { key: BrokerNetworkEnum.BeneficialLimited, displayName: "Beneficial Limited", order: 23 },
        { key: BrokerNetworkEnum.JulianHarris, displayName: "Julian Harris", order: 24 },
        {
          key: BrokerNetworkEnum.DragonBrokersLimited,
          displayName: "Dragon Brokers Limited",
          order: 25,
        },
        {
          key: BrokerNetworkEnum.JohnCharcolLimited,
          displayName: "John Charcol Limited",
          order: 26,
        },
        {
          key: BrokerNetworkEnum.CornerstoneFinancial,
          displayName: "Cornerstone Financial",
          order: 27,
        },
        { key: BrokerNetworkEnum.CorbelPartners, displayName: "Corbel Partners", order: 28 },
        { key: BrokerNetworkEnum.RichdaleBrokers, displayName: "Richdale Brokers", order: 29 },
        { key: BrokerNetworkEnum.PJFinancialLtd, displayName: "PJ Financial Ltd", order: 30 },
        {
          key: BrokerNetworkEnum.JLMMortgageNetwork,
          displayName: "JLM Mortgage Network",
          order: 31,
        },
        { key: BrokerNetworkEnum.IngrandFinancial, displayName: "Ingrand Financial", order: 32 },
      ];
    }
    return this.SelectLists["BrokerNetworkEnum"].sort((a, b) => a.displayName.localeCompare(b.displayName));
  }

  GetLenderSubscriptionTypeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["LenderSubscriptionTypeEnum"] == null) {
      this.SelectLists["LenderSubscriptionTypeEnum"] = [
        { key: LenderSubscriptionTypeEnum.PoS, displayName: "PoS", order: 2 },
        { key: LenderSubscriptionTypeEnum.Saas, displayName: "Saas", order: 3 },
        { key: LenderSubscriptionTypeEnum.SaasPoS, displayName: "Saas/PoS", order: 4 },
      ];
    }
    return this.SelectLists["LenderSubscriptionTypeEnum"].sort((a, b) => a.displayName.localeCompare(b.displayName));
  }

  GetBrokerSubscriptionTypeOptions(): ListItem[] {
    if (this.SelectLists == null || this.SelectLists["BrokerSubscriptionTypeEnum"] == null) {
      this.SelectLists["BrokerSubscriptionTypeEnum"] = [
        { key: BrokerSubscriptionTypeEnum.Enterprise, displayName: "Enterprise", order: 1 },
        { key: BrokerSubscriptionTypeEnum.EnterprisePartners, displayName: "Enterprise Partners", order: 2 },
        { key: BrokerSubscriptionTypeEnum.Standard, displayName: "Standard", order: 3 },
      ];
    }
    return this.SelectLists["BrokerSubscriptionTypeEnum"].sort((a, b) => a.displayName.localeCompare(b.displayName));
  }

  decodeBitwiseEnum(bitwiseValue: number, options: ListItem[]): ListItem[] {
    return options.filter((option) => (bitwiseValue & option.key) === option.key);
  }

  encodeBitwiseEnum(selectedKeys: ListItem[]): number {
    const keys = selectedKeys.map((item) => item.key);
    return keys.reduce((acc, key) => acc | key, 0);
  }
}
